import React, { type ComponentProps } from 'react';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';
import { HorizontalScrollRail } from '@garnish/layout';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * The rail that contains the reward cards for the bag.
 */
export const BagRewardsRail = (
  props: Pick<
    ComponentProps<typeof HorizontalScrollRail>,
    | 'children'
    | 'heading'
    | 'showNavControls'
    | 'headingIcon'
    | 'outerOffset'
    | 'gap'
    | 'onScroll'
    | 'onContentSizeChange'
    | 'scrollEnabled'
  >,
) => {
  const { minWidth } = useResponsive();

  const {
    showNavControls = minWidth.isSM,
    outerOffset = -theme.spacing['4'],
    heading,
    headingIcon,
    gap = theme.spacing['2'],
    children,
    onScroll,
    onContentSizeChange,
  } = props;

  return (
    <HorizontalScrollRail
      withoutHeaderBorder
      heading={heading}
      headingIcon={headingIcon}
      showNavControls={showNavControls}
      gap={gap}
      outerOffset={outerOffset}
      countPosition={minWidth.isSM ? 'left' : 'right'}
      onScroll={onScroll}
      onContentSizeChange={onContentSizeChange}
    >
      {children}
    </HorizontalScrollRail>
  );
};
